export default __webpack_public_path__ + "static/media/1-icon-folder-open-20-px.d9539c68.svg";